module.exports = __webpack_public_path__ + "static/media/logoutnew.b13f87f3.svg";